import { render, staticRenderFns } from "./community-standards.vue?vue&type=template&id=7215b896&scoped=true&"
import script from "./community-standards.vue?vue&type=script&lang=js&"
export * from "./community-standards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215b896",
  null
  
)

export default component.exports